if (!customElements.get('koyo-purchase-bar')) {
  customElements.define('koyo-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      const section = this.closest('product-info');
      const options = section?.querySelector(`#KoyoOptions-${this.dataset.section}`);
      const form = section?.querySelector('product-form');
      if (!options || !form) return;

      const visible = new Map();
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => visible.set(entry.target, entry.isIntersecting));
        this.hidden = [...visible.values()].some(Boolean);
      }, { rootMargin: '-80px 0px -80px 0px' });
      this.observer.observe(options);
      this.observer.observe(form);
      this.dataset.ready = '';
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
